import { AnalyticsService } from "./services/analytics.service";
import { LoginService } from "./services/login.service";

export function initialiseData(loginService: LoginService, analytics: AnalyticsService) {
    return () => {
        analytics.init();
        return loginService.validateToken(false);
    }
}